import { Skeleton } from "primereact/skeleton";
import { formatNumber } from "../widgets/graphs/chartTheme.ts";
import "../ui/number-box/numberbox.css";

export interface NumberBoxItem {
  key: string;
  titulo: string;
  // Any CSS color, e.g. "var(--color-aprobadas)" or "#1aa37a"
  color: string;
  value: number;
  // Tooltip, e.g. what the click opens
  hint?: string;
  onClick?: () => void;
}

interface NumberBoxesProps {
  items: NumberBoxItem[];
  loading: boolean;
  error: string | null;
  // Optional heading above the boxes, with a secondary note
  titulo?: string;
  nota?: string;
}

/**
 * "Big numbers" strip with the look of the legacy index NumberBox row
 * (numberbox.css). Boxes with onClick behave as links (mouse + keyboard).
 */
export default function NumberBoxes({
  items,
  loading,
  error,
  titulo,
  nota,
}: NumberBoxesProps) {
  return (
    <div className="rp-estados" aria-label={titulo ?? "Cantidad por estado"}>
      {titulo ? (
        <div className="rp-estados-head">
          <span className="rp-estados-head-title">{titulo}</span>
          {nota ? <span className="rp-estados-head-note">{nota}</span> : null}
        </div>
      ) : null}
      {/* The heading stays outside the grid: an item spanning 1 / -1 would
          keep every auto-fit track alive and the boxes would not stretch */}
      <div className="rp-estados-grid">
        {items.map((b) => (
          <div
            key={b.key}
            className={`numberbox${b.onClick ? "" : " rp-estados-static"}`}
            style={{ backgroundColor: b.color }}
            role={b.onClick ? "link" : undefined}
            tabIndex={b.onClick ? 0 : undefined}
            title={b.hint}
            onClick={b.onClick}
            onKeyDown={
              b.onClick
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      b.onClick?.();
                    }
                  }
                : undefined
            }
          >
            <span className="rp-estados-title">{b.titulo}</span>
            {loading ? (
              <Skeleton
                width="60%"
                height="1.6rem"
                className="rp-estados-skeleton"
              />
            ) : (
              <span className="rp-estados-value">
                {error ? "-" : formatNumber(b.value)}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
